<div class="login-area">
  <div class="login-container element-column">
    <img class="logo" alt="logo" src="/assets/img/peace_logo_yoko.png" />
      <div class="login-content block-column">
        <div class="login-detail">
          <h2>入力したユーザのパスワード再設定を行います。</h2>
          <div class="column-list">
            <label class="list-input-title">ユーザID</label>
            <div class="list-input-content">
              <input type="text" id="tbx_user" class="userid" #tbx_user [maxlength]="256" plessInputTextSub
                [restrict]="'[a-zA-Z0-9@!#&amp;$%\'*+\-/=?\^_`\{\|\}~.]'" [(ngModel)]="model.userId" [autofocus]="true" [tabindex]="0"
                autocomplete="off" />
            </div>
          </div>
        </div>
        <div class="layout_balance">
          <button class="btn-tartiary" (click)="eventReturnHanler()">戻る</button>
          <button class="left-button" id="btn_login" class="btn-primary"
            (click)="eventSendPassResetEmailHandler()" [tabindex]="0">送信</button>
        </div>
      </div>
  </div>
</div>
  